const SIZES= {
    containerWidth: '950',
    containerMarginText: '10px 0',
    containerPadding: '50px auto',
}

export default SIZES